export const detectSpaceWhite = (str: string | null | undefined) => {
    if (str as string) {
        if (!str?.trim().length) return true;
    }
    if (str === undefined || str === null) return true;
    return false;
};
